import { ChronicleFilenamesEnum, PlanningModeEnum } from "shared/enums/globalEnums";
import { FcrNPlanningConfig, FcrNPlanningEnum, TrialEngagementEnum } from "../shared/types";

export const fcrNPlanningConfigurations: FcrNPlanningConfig[] = [
  {
    name: FcrNPlanningEnum.planning_soc_1,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 50,
    fcrn_engagement: null,
    targetSoc: 0.45,
    chronicleFilename: null,
  },
  {
    name: FcrNPlanningEnum.planning_trial_1,
    mode: PlanningModeEnum.fingrid_fcrn,
    durationInMinutes: 540,
    fcrn_engagement: TrialEngagementEnum.maximalOperationalPower,
    targetSoc: null,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_n_test_1_540min,
  },
  {
    name: FcrNPlanningEnum.planning_soc_2a,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 30,
    fcrn_engagement: null,
    targetSoc: 0.5,
    chronicleFilename: null,
  },
  {
    name: FcrNPlanningEnum.planning_trial_2a,
    mode: PlanningModeEnum.fingrid_fcrn,
    durationInMinutes: 25,
    fcrn_engagement: TrialEngagementEnum.minimalOperationalPower,
    targetSoc: null,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_n_test_2_22min,
  },
  {
    name: FcrNPlanningEnum.planning_soc_2b,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 20,
    fcrn_engagement: null,
    targetSoc: 0.5,
    chronicleFilename: null,
  },
  {
    name: FcrNPlanningEnum.planning_trial_2b,
    mode: PlanningModeEnum.fingrid_fcrn,
    durationInMinutes: 25,
    fcrn_engagement: TrialEngagementEnum.maximalOperationalPower,
    targetSoc: null,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_n_test_2_22min,
  },
  {
    name: FcrNPlanningEnum.planning_soc_3,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 30,
    fcrn_engagement: null,
    targetSoc: 0.5,
    chronicleFilename: null,
  },
  {
    name: FcrNPlanningEnum.planning_trial_3,
    mode: PlanningModeEnum.fingrid_fcrn,
    durationInMinutes: 80,
    fcrn_engagement: TrialEngagementEnum.minimalOperationalPower,
    targetSoc: null,
    chronicleFilename: ChronicleFilenamesEnum.fin_certification_fingrid_fcr_n_sin10_300_1h20,
  },
  {
    name: FcrNPlanningEnum.planning_soc_1h,
    mode: PlanningModeEnum.soc_management,
    durationInMinutes: 30,
    fcrn_engagement: null,
    targetSoc: 0.5,
    chronicleFilename: null,
  },
  {
    name: FcrNPlanningEnum.planning_trial_1h,
    mode: PlanningModeEnum.fingrid_fcrn,
    durationInMinutes: 60,
    fcrn_engagement: TrialEngagementEnum.maximalOperationalPower,
    targetSoc: null,
    chronicleFilename: null,
  },
];
